export function forOrgAndLang(org, lang) {
  if (org === 'DELFT' && lang === 'NL') {
    return 'NL-NL';
  }else  if (org === 'DELFT' && lang === 'EN') {
    return 'EN-NL';
  }else {
    return `${lang}-${org}`;
  }
}

export function getPathForLanguage(language) {
  return language.substring(0, 2);
}

